/**
 * Formats unit size text based on whether it contains "long"
 * @param {string} unitSize - The unit size text to format
 * @returns {string} - Formatted unit size text
 */
export const formatUnitSize = (unitSize) => {
	if (!unitSize) return '';

	return unitSize.toLowerCase().includes('long')
		? removeApostrophesOnly(unitSize)
		: removeWhitespaceAndApostrophes(unitSize);
};

/**
 * Removes only apostrophes from unit size text, keeping whitespace
 * @param {string} unitSize - The unit size text
 * @returns {string} - Text with apostrophes removed
 */
export const removeApostrophesOnly = (unitSize) => {
	return unitSize.replaceAll("'", '');
};

/**
 * Removes both whitespace and apostrophes from unit size text
 * @param {string} unitSize - The unit size text
 * @returns {string} - Text with whitespace and apostrophes removed
 */
export const removeWhitespaceAndApostrophes = (unitSize) => {
	return unitSize.replaceAll(/[\s']+/g, '');
};
